import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AuthProvider from './hooks/AuthProvider';
import PrivateRoute from "./router/router";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";

import MainApplication from "./components/MainApplication";  // here MainApplication refers to BaseTemplate in FCB project
import LoginForm from "./components/Login";
import MyWalletRedirect from "./components/MyWallet/MyWalletRedirect";
import ZohoCallback from "./components/Zoho/ZohoCallback";
import TenantOnboardingPage from './components/Onboarding/TenantOnboardingPage';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="/signup" element={<TenantOnboardingPage />} />
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<MainApplication />} />
              <Route path="/verify" element={<MyWalletRedirect />} />
              <Route path="/callback" element={<ZohoCallback />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
